import { createContext, FC, PropsWithChildren } from 'react'
import { StencilContextType, useStencilCreate } from '../useStencilCreate'

export const StencilContext = createContext<StencilContextType | null>(null)

export const ProvideStencilContext: FC<PropsWithChildren> = ({ children }) => {
  const context = useStencilCreate()
  return <StencilContext.Provider value={context}>{children}</StencilContext.Provider>
}
